import {useEffect} from "react";

const FieldSpecRepeater = ({ name, value, onChange }) => {

  if ( !name ) {
    console.log("Field name was not specified...")
    return
  }

  const fieldSpecs = {
    'text': 'Text',
    'number': 'Number',
    'select': 'Select',
    'masked': 'Mask',
    // 'dynamic': 'Dynamic'
  }

  const repeater = tangibleFields.render({
    type: 'repeater',
    name: name,
    context: 'wp',
    layout: 'advanced',
    value: value.length? value: {},
    onChange: onChange?? null,
    fields: [
      { type: 'text', name: `label`, label: 'Field' },
      { type: 'select', name: `type`, label: 'Field Display', choices: fieldSpecs },
      {
        type: 'text',
        name: `value_text`,
        //label: 'Default Value',
        condition: {
          action: 'show',
          condition: { [`type`]: { '_eq': 'text' } }
        }
      }, {
        type: 'number',
        name: `value_number`,
        // label: 'Default Value',
        condition: {
          action: 'show',
          condition: { [`type`]: { '_eq': 'number' } }
        }
      }, {
        type: 'text',
        name: `value_select`,
        label: 'Default Value',
        condition: {
          action: 'show',
          condition: { [`type`]: { '_eq': 'select' } }
        }
      }, {
        type: 'text',
        name: `options`,
        label: 'Options',
        condition: {
          action: 'show',
          condition: { [`type`]: { '_eq': 'select' } }
        }
      }, {
        type: 'text',
        name: `prefix`,
        //label: 'PREFIX',
        placeholder: 'PREFIX',
        condition: {
          action: 'show',
          condition: { [`type`]: { '_eq': 'masked' } }
        }
      }, {
        type: 'text',
        name: `mask`,
        placeholder: 'MAIN NUMBER MASK',
        condition: {
          action: 'show',
          condition: { [`type`]: { '_eq': 'masked' } }
        }
      }, {
        type: 'text',
        name: `suffix`,
        placeholder: 'SUFFIX',
        condition: {
          action: 'show',
          condition: { [`type`]: { '_eq': 'masked' } }
        }
      }
    ],
    wrapper : {
      class: 'tgbl-field-spec-repeater'
    }
  })

  return (
    <div className="tf-custom-repeater">
      { repeater }
    </div>
  )
}

export { FieldSpecRepeater }
